import PropTypes from "prop-types";
import CategoryHtmlDescription from "../CategoryHtmlDescription";

const CategoryFooterDescription = ({ description }) => (
  <CategoryHtmlDescription
    description={description}
    testId="footer-description-container"
  />
);

CategoryFooterDescription.propTypes = {
  description: PropTypes.string
};

export default CategoryFooterDescription;
